<div class="obg-m-ksa-session-limit-header">
	<img obgImageContent="general.session-limit-time" />
	<div>
		<h1>{{ 'multi-session-limit.title' | translate }}</h1>
		<p>{{ 'multi-session-limit.description' | translate }}</p>
	</div>
</div>

<div class="obg-m-ksa-session-limit-queued-notification" *ngIf="upcomingSessionLimit">
	<span class="notification-icon ico-exclamation"></span>
	<label
		[innerHTML]="'multi-session-limit.upcoming-limit.' + (upcomingSessionLimit.limitPeriod | lowercase) | translate: {
				queuedLimit: upcomingSessionLimit.limitValue,
				activeFrom: upcomingSessionLimit.activeFrom | date: 'dd MMMM yyyy'
			}"
		test-id="upcoming-limit"
	>
	</label>
	<button (click)="undoUpcomingLimit()" test-id="button-undo-upcoming-limit">
		{{ 'multi-session-limit.upcoming-limit.undo' | translate }}
	</button>
</div>

<mat-card class="obg-m-ksa-session-limit-container">
	<h2>{{ 'multi-session-limit.title' | translate }}</h2>
	<div>
		<span>{{ 'multi-session-limit.current-limit' | translate }}</span>
		<span
			class="obg-m-ksa-session-limit-amount"
			*ngIf="currentSessionLimitConverted; else noLimit"
			[innerHTML]="'multi-session-limit.current-limit.' + (currentSessionLimitConverted.limitPeriod | lowercase) | translate: {
				limit: currentSessionLimitConverted.limitValue }"
			test-id="current-limit-amount"
		>
		</span>

		<ng-template #noLimit>
			<span>{{ "general.not-set" | translate }}</span>
		</ng-template>
	</div>
	<div class="btn-container" *ngIf="!isSessionLimitEdited">
		<button
			mat-flat-button
			color="accent"
			(click)="editSessionLimit()"
			[disabled]="isSettingBusy"
			test-id="button-change-session-limit"
		>
			<mat-spinner *ngIf="isSettingBusy; else showContent" diameter="20"></mat-spinner>
			<ng-template #showContent>{{ 'multi-session-limit.change-session-limit' | translate }}</ng-template>
		</button>
	</div>
</mat-card>
<mat-card class="obg-m-ksa-session-limit-edit" *ngIf="isSessionLimitEdited">
	<form [formGroup]="formGroup" #form="ngForm" (ngSubmit)="submitNewLimit()">
		<h2>{{ 'responsible-gaming.enter-session-time-limits' | translate }}:</h2>

		<mat-radio-group formControlName="sessionLimitPeriod">
			<mat-radio-button
				[value]="sessionLimitPeriodControls.Daily"
				[checked]="true"
				color="primary"
				test-id="session-limit-period-daily"
				>{{ 'multi-session-limit.daily' | translate }}</mat-radio-button
			>
			<mat-radio-button
				[value]="sessionLimitPeriodControls.Weekly"
				color="primary"
				test-id="session-limit-period-weekly"
				>{{ 'multi-session-limit.weekly' | translate }}</mat-radio-button
			>
			<mat-radio-button
				[value]="sessionLimitPeriodControls.Monthly"
				color="primary"
				test-id="session-limit-period-monthly"
				>{{ 'multi-session-limit.monthly' | translate }}</mat-radio-button
			>
		</mat-radio-group>

		<mat-form-field floatLabel="always">
			<mat-label>{{ 'multi-session-limit.label' | translate }}</mat-label>
			<input
				matInput
				type="tel"
				[placeholder]="placeholder"
				formControlName="sessionLimitAmount"
				test-id="input-session-limit-amount"
				obgNumericNotZero
				required
			/>
		</mat-form-field>

		<obg-common-validation-renderer
			[input]="formGroup.controls.sessionLimitAmount"
			translationPrefix="multi-session-limit"
		>
		</obg-common-validation-renderer>

		<div class="btn-container">
			<button
				mat-flat-button
				color="accent"
				type="submit"
				[disabled]="!formGroup.valid"
				test-id="button-set-session-time-limit"
			>
				{{ 'multi-session-limit.set-session-time-limits' | translate }}
			</button>
		</div>
	</form>
</mat-card>

<div class="caption" [innerHtml]="'multi-session-limit.information'| translate"></div>
